module.exports = "/_next/static/images/64e1e678ec140408b3c6305893c6907d-roxinho-single-xs@3x.jpg.webp";